import React from 'react';
import './Loader.css';

function Loader({ loading }) {
    return (
        <>
            {loading && (
                <div className="smooth-loader-container">
                    <div className="loader-content">
                        <div className="animated-spinner">
                            <div className="spinner-ring"></div>
                            <div className="spinner-ring"></div>
                            <div className="spinner-ring"></div>
                        </div>
                        <p className="loader-text">Loading...</p>
                    </div>
                </div>
            )}
        </>
    );
}

export default Loader;
